import {
  CapacityGranularity,
  CapacitySort,
  Filter,
  OccupancyBand,
} from "@planzone/dto";
import { State } from "./types";

function computeOccupancy(
  load: number,
  capacity: number,
): { occupancy: number; band: OccupancyBand } {
  if (capacity === 0) {
    return load === 0
      ? { occupancy: 0, band: "NONE" }
      : { occupancy: -1, band: "OVER" };
  }

  const ratio = (load / capacity) * 100;
  const band: OccupancyBand =
    ratio <= 100 ? "OK" : ratio < 130 ? "WARN" : "OVER";

  return { occupancy: Math.round(ratio), band };
}

function matchRequest(
  state: State,
  from: string,
  to: string,
  granularity: CapacityGranularity,
  filter: Filter | undefined,
  sort: CapacitySort | undefined,
  size: number,
): number {
  return state.findIndex(
    (req) =>
      req.from === from &&
      req.to === to &&
      req.granularity === granularity &&
      req.sort === sort &&
      req.size === size &&
      JSON.stringify(req.filter || {}) === JSON.stringify(filter || {}),
  );
}

export { computeOccupancy, matchRequest };
